import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { TimeWindowGroupDto } from "../../../models/time-window/dto/time-window.dto";

export const GET_TIME_WINDOW_GROUPS_QUERY_KEY = (organizationId?: string) =>
    organizationId ? ['timeWindowGroups', organizationId] : ['timeWindowGroups'];

export const useGetTimeWindowGroups = (organizationId?: string) => {
    const client = useApiClient();
    return useQuery({
        queryKey: GET_TIME_WINDOW_GROUPS_QUERY_KEY(organizationId),
        queryFn: () => {
            if (!organizationId) {
                throw new Error('Organization ID is required');
            }
            return client.fetchApi<TimeWindowGroupDto[], void>({
                endpoint: `time-windows/organizations/${organizationId}/groups`,
                method: 'GET'
            });
        },
        enabled: !!organizationId,
        staleTime: 30_000
    });
};